import $ from 'jquery'
import { colourStringToRgbaParts, isLight } from './utils/colorUtils'

export function init() {
  $('[data-auto-color]').each((i, elem) => {
    const background = $(elem).data('auto-color')
    const rgba = colourStringToRgbaParts(background)
    const bgLight = isLight(rgba)
    console.log(rgba, bgLight)
    $(elem).addClass(bgLight ? 'text-dark' : 'text-white')
  })
}
